import { Button, message, Table, Tooltip } from "antd";
import { useActionHandler } from "../ActionHandlerContext";
 
import * as AntIcons from "@ant-design/icons";

const StaticTable = ({ datasource }) => {
  const columns = datasource?.columns ?? [];
  const data = datasource?.data ?? [];
  const actionButtons = datasource?.actionConfig ?? [];
  const { rowActionHandler } = useActionHandler();
   

  console.log(actionButtons);

  const handleActionButtonClick = async (
    button: any,
    recordId: any,
    record: any
  ) => {
    let actionType = button?.actions?.[0].execData;

    try {
      console.log(
        "typeof rowActionHandler[actionType]:",
        typeof rowActionHandler[actionType]
      );
      if (rowActionHandler[actionType]) {
        // Call the appropriate handler and wait for the result (if it's async)
        const result = await rowActionHandler[actionType](actionType, record);
        // Handle success
        if (result) {
          message.success(
            `Handler for ${actionType} executed successfully: ${result}`
          );
        }
      } else {
        message.error(`No handler found for ${actionType}`);
      }
    } catch (error) {
      // Handle error
      message.error(
        `Error executing handler for ${actionType}: ${error.message}`
      );
    } finally {
      // Set the loading state for the specific record and button to false
      //   setLoadingState((prevState) => ({
      //     ...prevState,
      //     [recordId]: { ...prevState[recordId], [type]: false },
      //   }));
    }
  };

  const getIcon = (iconName) => {
    const Icon = AntIcons[iconName];
    if (Icon) {
      return <Icon />;
    }
    // If icon name is not found, return null or a default icon (optional)
    return null;
  };

  let actionColumn = "";
  if (actionButtons) {
    actionColumn = {
      title: "Actions",
      key: "actions",
      fixed: "right",
      width: 100,
      render: (_: any, record: { key: string | number }) => (
        <div style={{ display: "flex", gap: "8px" }}>
          {/* <Tooltip  title={'abc'}>
                  <Button
                    //key={index}
                    icon={getIcon('PlusOutlined')}
                    onClick={() =>
                      handleActionButtonClick(null, record.key, record)
                    }
                    type="link"
                    //title={button.type}
                    //loading={loadingState[record.key]?.[button.type]}
                  ></Button>
                </Tooltip> */}
          {actionButtons.map((button: any, index: number) => (
            <Tooltip key={ crypto.randomUUID()} title={button?.label}>
              <Button
                key={ crypto.randomUUID()}
                icon={getIcon(button?.icon)}
                onClick={() =>
                  handleActionButtonClick(button, record.key, record)
                }
                type="link"
                //title={button.type}
                //loading={loadingState[record.key]?.[button.type]}
              ></Button>
            </Tooltip>
          ))}
        </div>
      ),
    };
  }

  const mergedColumns = [
    ...(columns ?? []).map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        sorter: true,
        onCell: (record: Item) => ({
          record,
          inputType: col.dataIndex === "age" ? "number" : "text",
          dataIndex: col.dataIndex,
          //editing: isEditing(record),
        }),
      };
    }),
    actionColumn,
  ];

  return columns.length > 0 && data.length > 0 ? (
    <Table
      columns={mergedColumns}
      dataSource={data}
      scroll={{ x: "max-content" }}
      rowKey="Key" // make sure your data rows have a `key` property
    />
  ) : (
    <div>No data available</div>
  );
};

export default StaticTable;
